import React from "react";
import { signin } from "../api/authApi";
import IsValidSignInData from "./ValidationChecker/signinValidation";
import AuthForm from "./common/authForm/AuthForm";

const Login = () => {

    const handleSubmit = (values, callback) => {
        signin(values, callback);
    };
    const customFields = [
        {
            name: "email",
            type: "email",
            placeholder: "E-mail",
            label: "Email",
        },
        {
            name: "password",
            type: "password",
            placeholder: "Password",
            label: "Password",
        },
        {
            name: "remember_me",
            type: "checkbox",
            label: "Remember Me",
            required: false,
        },
    ]

    return (
        <AuthForm
            formType="Log-In"
            initialValues={{ email: "", password: "", remember_me: false, }}
            validationFunc={IsValidSignInData}
            onSubmit={handleSubmit}
            successRedirectPath="/admin/dashboard"
            buttonLabel="Sign-In"
            loadingLabel="Signing In..."
            customLinks={[
                { to: "/register", label: "Create User" },
                { to: "/forgot-password", label: "Forgot Password" },
            ]}
            customFields={customFields}
        />
    );
};

export default Login;
